export default async function () {
  const storyBlock = document.getElementById("latest-blog");
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  if (storyBlock) {
    const story = {};
    const result = await fetch("https://blog.wildermuth.com/feed.xml");
    const data = await result.text();
    const parser = new DOMParser();
    const xml = parser.parseFromString(data, "text/xml");
    const stories = xml.getElementsByTagName("entry");
    const storyElement = stories[0];
    story.title = storyElement.getElementsByTagName("title")[0].textContent;
    story.updated = new Date(storyElement.getElementsByTagName("updated")[0].textContent);
    story.url = storyElement.getElementsByTagName("link")[0].attributes.getNamedItem("href").value;
    const imageElement = storyElement.getElementsByTagName("itunes:image")[0];
    story.imageUrl = imageElement.textContent;
    story.content = storyElement.getElementsByTagName("content")[0].textContent;
    const storyTitle = document.getElementById("storyTitle");
    storyTitle.innerText = story.title;
    const image = storyBlock.getElementsByTagName("img")[0];
    image.src = story.imageUrl;
    image.alt = story.title;
    const storyDate = document.getElementById("storyDate");
    const locale = document.documentURI.indexOf("/en/") >= 0 ? "en" : "nl";
    storyDate.innerText = story.updated.toLocaleDateString(locale, options);
    const content = document.getElementById("storyDescription");
    content.innerHTML = story.content;
    const links = storyBlock.getElementsByTagName("a");
    for (let i = 0; i < links.length; ++i) links[i].href = story.url;
  }
}